import Hub from "../Svg/Hub";
import Room from "../Svg/Room";
import TwinHub from "../Svg/TwinHub";
import MovieHub from "../Svg/MovieHub";
import { useEffect, useState } from "react";

export default function ReservationCardCategoryName(props: {
  names: { [key: string]: string };
  languageCode: string;
  rename?: boolean;
  showIcon?: boolean;
}) {
  const { names, languageCode, rename = false, showIcon = true } = props;
  const [name, setName] = useState(names[languageCode] || names["en-US"]);

  const renamed: any = {
    Hub: "Hub",
    "Twin Hub": "Twin Hub",
    Room: "Quad room",
    "Movie Hub": "Movie Hub",
  };

  useEffect(() => {
    if (names[languageCode] !== undefined) {
      setName(names[languageCode]);
    }
  }, [languageCode, names]);

  return (
    <div className="w-full flex items-center gap-x-1 text-center">
      {showIcon && (
        <div className="flex gap-1">
          {name === "Hub" && <Hub className="size-fluid-4" />}
          {name === "Twin Hub" && <TwinHub className="size-fluid-4" />}
          {name === "Room" && (
            <>
              <Room className="size-fluid-4" /> <Room className="size-fluid-4" />
            </>
          )}
          {name === "Movie Hub" && <MovieHub className="size-fluid-4" />}
        </div>
      )}
      <span className="whitespace-nowrap">
        {!rename && name}
        {rename && renamed[name]}
      </span>
    </div>
  );
}
